import { CUTTING_GROUP_NAME, CUTTING_OUTLINE_NAME } from '@/littleWedding/fabricGroupsName';
import { Group, type Canvas } from 'fabric';
import type { IGroup } from '@/typescript/interfaces/IGroup';

function createLockedBackgroundObjectGroup(fabricCanvas: Canvas, groupName: string) {
    const lockedGroup = new Group([], {
        selectable: false,
        evented: false,
        visible: true,
    });

    lockedGroup.set('id', groupName);
    fabricCanvas?.add(lockedGroup);
    fabricCanvas?.sendObjectToBack(lockedGroup);
    const bgGroup = fabricCanvas.getObjects('group').find((group) => {
        return !(group as Group & { id: string })?.id;
    });
    if (bgGroup) {
        // If this is called before display canvas fullScreen, then canvas center on the top left corner, not at center
        fabricCanvas?.sendObjectToBack(bgGroup);
    }
}

function createCuttingGroup(fabricCanvas: Canvas, groupName: string) {
    const cuttingGroup = new Group([], {
        visible: true,
        selectable: false,
        evented: false,
    });
    cuttingGroup.set('id', groupName);
    fabricCanvas?.add(cuttingGroup);
    return cuttingGroup;
}

function keepLockedBackgroundObjectGroupToBack(fabricCanvas: Canvas, groupName: string) {
    const bgLockedGroup = (fabricCanvas?.getObjects('group') as IGroup[]).find((group) => {
        return group?.id === groupName;
    });
    if (bgLockedGroup) {
        fabricCanvas?.sendObjectToBack(bgLockedGroup);
    }
    const bgGroup = (fabricCanvas?.getObjects('group') as IGroup[]).find((group) => {
        return !group?.id;
    });
    if (bgGroup) {
        fabricCanvas?.sendObjectToBack(bgGroup);
    }
    const cuttingGroup = (fabricCanvas?.getObjects('group') as IGroup[]).find((group) => {
        return group?.id === CUTTING_GROUP_NAME;
    });
    if (cuttingGroup) {
        fabricCanvas?.bringObjectToFront(cuttingGroup);
    }
    const cuttingOutline = (fabricCanvas?.getObjects('group') as IGroup[]).find((group) => {
        return group?.id === CUTTING_OUTLINE_NAME;
    });
    if (cuttingOutline) {
        fabricCanvas.bringObjectToFront(cuttingOutline);
    }
    fabricCanvas?.renderAll();
}

function getFabricGroupById(fabricCanvas: Canvas, groupId?: string): IGroup | undefined {
    return (fabricCanvas.getObjects('group') as IGroup[]).find((group) => {
        if (groupId) {
            return group?.id === groupId;
        } else {
            return group?.id === undefined;
        }
    });
}

export { createCuttingGroup, createLockedBackgroundObjectGroup, getFabricGroupById, keepLockedBackgroundObjectGroupToBack };
